"use client";
import SvgCoffeeFilled from "./coffee-filled.svg.js";
import SvgCoffeeOutlined from "./coffee-outlined.svg.js";
import SvgCoffeeRound from "./coffee-round.svg.js";
import SvgCoffeeSharp from "./coffee-sharp.svg.js";
const coffee = {
  filled: SvgCoffeeFilled,
  outlined: SvgCoffeeOutlined,
  round: SvgCoffeeRound,
  sharp: SvgCoffeeSharp
};
export {
  coffee
};
